import { useEffect, useState } from 'react';

import { useHistory, withRouter } from 'react-router-dom';
import { DateTime } from 'luxon';

import { useStudentJoinLiveClassMutation } from '@school_ify/schoolify-repository/src/student/types';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';
import {
  getClassDetails,
  joinLiveClassState,
  teacherJoin,
} from 'redux/liveClass/joinLiveClass.slices';
import UseLiveClassDetails from 'hooks/useLiveClassDetails';
import Header from 'components/LiveClassComponents/Header/Header';
import Card from 'components/Card/Card';

import Board from './components/Board/Board';
import Controls from './components/Controls/Controls';

import './ClassVideo.scoped.scss';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import { teacherCreateLiveClassState } from 'redux/liveClass/teacherCreateLiveClass.slices';

const Index = ({ match }) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [classUrl, setClassUrl] = useState<string>('');
  const user = useAppSelector(getUser);
  const { response, loading, classDetails } = useAppSelector(joinLiveClassState);
  const [isLoading, setLoading] = useState(false);
  const { model } = useAppSelector(teacherCreateLiveClassState);

  const { details, isClassRunning, classEnd } = UseLiveClassDetails();

  const [
    studentJoinLiveClassMutation,
    { data: studentJoinLiveLessonData, loading: studentLoading },
  ] = useStudentJoinLiveClassMutation();

  useEffect(() => {
    switch (user.role) {
      case 'teacher':
        dispatch(getClassDetails(match.params.id));
        dispatch(
          teacherJoin({
            name: `${user.title} ${user.first_name} ${user.last_name}`,
            lesson_id: match.params.id,
          })
        );
        break;
      case 'student':
        dispatch(getClassDetails(match.params.id));
        studentJoinLiveClassMutation({
          variables: {
            name: `${user.title} ${user.first_name} ${user.last_name}`,
            lesson_id: match.params.id,
          },
        });
        break;
      default: // do nothing
    }
  }, [match, user]);

  useEffect(() => {
    setLoading(true);
    if (loading === 'success') {
      const starts = DateTime.fromISO(model.starting_at).minus({
        minutes: 15,
      });
      const now = DateTime.now();
      if (response.id === '404' || starts > now) {
        setLoading(false);
        history.push('/live');
      } else {
        setClassUrl(response.url);
        setLoading(false);
      }
    }
  }, [loading, classDetails]);

  useEffect(() => {
    if (!studentLoading && studentJoinLiveLessonData) {
      setClassUrl(studentJoinLiveLessonData.studentJoin.url);
      setLoading(false);
    }
  }, [studentLoading]);

  useEffect(() => {
    if (!isClassRunning) {
      history.push('/live');
    }
  }, [isClassRunning]);

  if (isLoading) {
    return <LoadingIndicator />;
  }
  return (
    <div className="live-class-container p-2">
      <Card>
        <Card.Header>
          <Header showFullScreen={true} title={details.name}>
            <div>
              {/* <ClockIcon style={{color: '#F04F48', marginRight: 7}}/> */}
              <p>{classEnd}</p>
            </div>
          </Header>
        </Card.Header>

        <Card.Body style={{ position: 'relative', padding: 0 }}>
          <div className="body-container">
            <Board url={classUrl} />
            <Controls />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default withRouter(Index);
